//JB </>
import { getBackLink } from './utils';
import { Grid, Link, Text } from '@chakra-ui/react';
import TextLinkIcon from '../../Wrappers/TextLinkIcon';
import { RiArrowLeftLine } from 'react-icons/ri';

const BackLink = ({props}) => {
  const stateProps = props.stateProps;
  const formikProps = props.formikProps;
  const [backClick, backLinkLabel, showBackLink] = getBackLink(
    stateProps,
    formikProps,
  );
    return (
      <Grid templateColumns={2} justifyContent="space-between" width="100%" display="flex" marginBottom=".5rem">
        <TextLinkIcon>
          <RiArrowLeftLine fontSize={18} />
          <Link key="resumes" onClick={backClick}>
            <Text variant="link">Back to {backLinkLabel}</Text>
          </Link>
        </TextLinkIcon>
      </Grid>
    );
};

export default BackLink;